import React from 'react';
import cx from 'classnames';
import { IOption, FieldRenderProps } from '@treelab/panda';

import { InputTitle } from '../InputTitle';

/**
 * Input Radio component.
 */
interface IInputRadio extends FieldRenderProps<HTMLElement> {
  /** Passed down classname. */
  className?: string;
  /** Optional id indicator */
  id?: string;
  /** If background has a solid color */
  isReverse?: boolean;
  /** Is small */
  isSmall?: boolean;
  /** Mandatory option list */
  options: IOption[];
  /** Disabled option list */
  disabledIndexes?: number[];
  /** Optional title */
  title?: string;
}

interface IState {
  activeValue: any;
}

export class InputRadio extends React.PureComponent<IInputRadio, IState> {
  constructor(props: IInputRadio) {
    super(props);
    this.state = {
      activeValue: props.input.value || props.options[0].value,
    };
  }

  componentWillReceiveProps(nextProps: IInputRadio) {
    if (this.props.input.value !== nextProps.input.value) {
      this.setState({ activeValue: nextProps.input.value });
    }
  }

  render() {
    const {
      id,
      isSmall = false,
      isReverse = false,
      options,
      title,
      disabledIndexes = [],
      meta,
    } = this.props;

    const combinedRadioContainerClass = cx({
      'panda-input-radio-container': true,
      'panda-typography--P2': isSmall,
      'panda-typography--P1': !isSmall,
      'panda-input-radio-container--small': isSmall,
      'panda-input-radio-container--large': !isSmall,
      'panda-input-radio-container--reverse': isReverse,
    });

    return (
      <div className="panda-input-container" id={id}>
        {!!title && <InputTitle isReverse={isReverse} isSmall={isSmall} title={title} />}
        <div className={combinedRadioContainerClass}>
          {options.map((option: IOption, index: number) => {
            const isDisabled =
              disabledIndexes.findIndex((disabledIndex) => disabledIndex === index) !== -1;
            return (
              <button
                disabled={isDisabled || (meta && meta.submitting)}
                tabIndex={0}
                key={index}
                className={cx('panda-input-radio text-ellipsis', {
                  'panda-input-radio--active':
                    this.state.activeValue === option.value && !isDisabled,
                  'panda-input-radio-disabled': isDisabled,
                })}
                onClick={() => this.onValueClick(option)}
                type="button"
              >
                {option.name}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  onValueClick = (option: IOption) => {
    const {
      input: { onChange },
    } = this.props;

    if (option.value === this.state.activeValue) return;
    this.setState({ activeValue: option.value });
    onChange && onChange(option.value);
  };
}
